const initialState = {
    user: {}
}

export default initialState
